// One shared collator for "natural" ordering: Tower 2 before Tower 10.
//
// `a.localeCompare(b, undefined, { numeric: true })` builds a fresh
// Intl.Collator on every call. Inside a sort over a few thousand Areas rows
// that was the single largest cost of rebuilding the system sheets. Same
// ordering, built once.

const NATURAL = new Intl.Collator(undefined, { numeric: true });

export function naturalCompare(a: string, b: string): number {
  return NATURAL.compare(a, b);
}
